const ComponentBase=require('../../base/ComponentBase');
const CommonUtil=require('../../utils/CommonUtil');
const g2 = require('../../g2');
const Chinese = require('./Chinese');
/**
 * @constructor
 * @classdesc 台风预测组件
 * @augments G.base.ComponentBase
 * @alias G.biz.TyphoonForecast
 * @param {Object} options - 必填，构造参数；
 * @param {G.Map} options.map - 必填，地图对象
 * @param {Object} [options.service] 服务
 * @param {Object} [options.typhoon] 台风选项
 * @param {g2.carto.ElementLayer} [options.typhoon.layer] 台风图层
 * @param {String} [options.typhoon.id] 台风图层id，若传入options.typhoon.layer，则忽略
 * @param {Object} [options.typhoon.name] 风图层name，若传入options.typhoon.layer，则忽略
 * @param {Integer} [options.typhoon.zIndex] 风图层zIndex，若传入options.typhoon.layer，则忽略
 * @param {Object} [options.probability] 概率预测选项
 * @param {g2.carto.ElementLayer} [options.probability.layer] 概率预测图层
 * @param {String} [options.probability.id] 概率预测图层id，若传入options.probability.layer，则忽略
 * @param {Object} [options.probability.name] 概率预测图层name，若传入options.probability.layer，则忽略
 * @param {Integer} [options.probability.zIndex] 概率预测图层zIndex，若传入options.probability.layer，则忽略
*/
let component = ComponentBase.extend({
    options: {},
    initialize: function (options) {
        ComponentBase.prototype.initialize.call(this, options);
        //台风信息图层
        options.typhoon = options.typhoon||{};
        if (!!options.typhoon.layer) {
            this.typhoonLayer=options.layer;
        }else{
            this.typhoonLayer = new g2.carto.ElementLayer({
                id:options.typhoon.id||CommonUtil.newUUID32(),
                name:options.typhoon.name,
                map:options.map,
                zIndex:options.typhoon.zIndex||100
            })
        }
        //概率预测图层
        options.probability = options.probability||{};
        if (!!options.probability.layer) {
            this.probabilityLayer=options.layer;
        }else{
            this.probabilityLayer = new g2.carto.ElementLayer({
                id:options.probability.id||CommonUtil.newUUID32(),
                name:options.probability.name,
                map:options.map,
                zIndex:options.zIndex||100
            })
        }
        if (!!options.service) {
            this.setService(options.service)
        }
    },
    /**
     * @inheritdoc
     * 
     */
    load() {
        ComponentBase.prototype.load.call(this);
        //台风信息标识
        this.toolTipWareTyphoon = new g2.widget.TooltipWare({
            map: this.map
        });
        //概率预测标识
        this.toolTipWareProbability = new g2.widget.TooltipWare({
            map: this.map
        });
        this.map.addLayer(this.typhoonLayer);
        this.map.addLayer(this.probabilityLayer);        
    },
    /**
     * @inheritdoc
     * 
     */
    unload:function (){
        this.map.removeLayer(this.typhoonLayer);
        this.map.removeLayer(this.probabilityLayer);
        this.toolTipWareProbability.clear();
        this.toolTipWareProbability.clear();
        this.typhoonTooltipHash=null;
        this.probabilityTooltipHash=null;
        ComponentBase.prototype.unload.call(this);
    },   
    /**
     * @inheritdoc
     * 
     */ 
    destroy: function () {
        this.unload();
        ComponentBase.prototype.destroy.call(this);
    },
    /**
     * 绘制实时台风信息
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * @param opts {Object}
     * @param opts.id {String} element标识
     * @param opts.param {Object} 数据
     * @param opts.param.tfid {Object} 数据
     * @param [opts.data] {String|Object} 数据
     * @param [opts.format] {String} 数据类型：kml、geojson, 默认为kml
     * 
     */
    showTyphoonRealtime(opts){
        const self = this;
        return new Promise((resolve, reject) => {
            if (!!opts.data) {
                self._showTyphoon(opts).catch(function(error) {
                    reject(error);
                });
            }else{
                if (opts.param) {
                    this.service.getForecastRealtime({ tfid: opts.param.tfid }).then(function (data) {
                        if (data.data && data.data.typhoon) {
                            opts.data = data.data.typhoon;
                            self._showTyphoon(opts).catch(function(error) {
                                reject(error);
                            });                            
                        }else{
                            reject(new Error('无实时台风信息'));
                        }

                    }).catch(function(err){
                        reject(err);
                    })  
                }
            }
        })
       
    },    
    /**
     * 绘制台风信息
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * @param opts {Object}
     * @param opts.id {String} element标识
     * @param opts.param {Object} 数据
     * @param opts.param.tfid {Object} 数据
     * @param opts.param.time {Object} 数据
     * @param [opts.data] {String|Object} 数据
     * @param [opts.format] {String} 数据类型：kml、geojson, 默认为kml
     * 
     */
    showTyphoon(opts){
        const self = this;
        return new Promise((resolve, reject) => {
            if (!!opts.data) {
                self._showTyphoon(opts).catch(function(error) {
                    reject(error);
                });
            }else{
                if (opts.param) {
                    this.service.getForecastByTime({ tfid: opts.param.tfid, time: opts.param.time}).then(function (data) {
                        if (data.data && data.data.typhoon) {
                            opts.data = data.data.typhoon;
                            self._showTyphoon(opts).catch(function(error) {
                                reject(error);
                            });                           
                        }else{
                            reject(new Error('无该时间点台风信息'));
                        }
                    }).catch(function(err){
                        reject(err);
                    })
                }
            }
        })
    },

     /**
     * 绘制实时台风概率
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * @param opts {Object}
     * @param opts.id {String} element标识
     * @param opts.param {Object} 数据
     * @param opts.param.tfid {Object} 数据
     * @param opts.data {String|Object} 数据
     * @param [opts.format] {String} 数据类型：kml、geojson, 默认为kml
     * @param [opts.label] {Object} 标注信息配置
     * @param [opts.label.display] {boolean} 标注信息配置-是否显示，默认true
     * @param [opts.label.position] {boolean} 标注信息位置-top,bottom,left,right，默认为left
     * 
     */ 
    showProbabilityRealtime(opts){
        const self = this;
        return new Promise((resolve, reject) => {
            if (!!opts.data) {
                self._showProbability(opts).catch(function(error) {
                    reject(error);
                });
            }else{
                if (opts.param) {
                    this.service.getForecastRealtime({ tfid: opts.param.tfid }).then(function (data) {
                        if (data.data && data.data.wsp) {
                            opts.data = data.data.wsp;
                            self._showProbability(opts).catch(function(error) {
                                reject(error);
                            });                           
                        }else{
                            reject(new Error('无该时间点实时概率信息'));
                        }
                    }).catch(function(err){
                        reject(err);
                    })
                }
            } 
        })
       
    }, 
    /**
     * 绘制台风概率
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * @param opts {Object}
     * @param opts.id {String} element标识
     * @param opts.param {Object} 数据
     * @param opts.param.tfid {Object} 数据
     * @param opts.param.time {Object} 数据
     * @param opts.data {String|Object} 数据
     * @param [opts.format] {String} 数据类型：kml、geojson, 默认为kml
     * @param [opts.label] {Object} 标注信息配置
     * @param [opts.label.display] {boolean} 标注信息配置-是否显示，默认true
     * @param [opts.label.position] {boolean} 标注信息位置-top,bottom,left,right，默认为left
     * 
     */ 
    showProbability(opts){
        const self = this;
        return new Promise((resolve, reject) => {
            if (!!opts.data) {
                self._showProbability(opts).catch(function(error) {
                    reject(error);
                });
            }else{
                if (opts.param) {
                    this.service.getForecastByTime({ tfid: opts.param.tfid, time: opts.param.time }).then(function (data) {
                        if (data.data && data.data.typhoon) {
                            opts.data = data.data.typhoon;
                            self._showProbability(opts).catch(function(error) {
                                reject(error);
                            });                            
                        }else{
                            reject(new Error('无该时间点概率信息'));
                        }
                    }).catch(function(err){
                        reject(err);
                    })
                }
            }
        })
    },


    /**
     * 根据id移除台风信息
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * @param id {String} 标识
     * 
     */    
    removeTyphoon(id){
        for (let index = this.typhoonLayer.elements.length-1; index >=0 ; index--) {
            const element = this.typhoonLayer.elements[index];
            if (element.id===id) {
                this.typhoonLayer.remove(element);
            }
        }

        for (const key in this.typhoonTooltipHash) {
            if (this.typhoonTooltipHash.hasOwnProperty(key)) {
                const elements = this.typhoonTooltipHash[key];
                for (let index = 0; index < elements.length; index++) {
                    const _id = elements[index];
                    this.toolTipWareTyphoon.remove(_id);
                }
            }
        }        
    },
    /**
     * 根据id移除概率信息
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * @param id {String} 标识
     * 
     */      
    removeProbability(id){
        for (let index = this.probabilityLayer.elements.length-1; index >=0 ; index--) {
            const element = this.probabilityLayer.elements[index];
            if (element.id===id) {
                this.probabilityLayer.remove(element);
            }
        }
        for (const key in this.probabilityTooltipHash) {
            if (this.probabilityTooltipHash.hasOwnProperty(key)) {
                const elements = this.probabilityTooltipHash[key];
                for (let index = 0; index < elements.length; index++) {
                    const _id = elements[index];
                    this.toolTipWareProbability.remove(_id);
                }
            }
        }
    },
    /**
     * 移除台风信息
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * 
     */      
    clearTyphoon(){
        this.typhoonLayer.clear();
        this.toolTipWareTyphoon.clear();
    },
    /**
     * 移除台风概率信息
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * 
     */      
    clearProbability(){
        this.probabilityLayer.clear();
        this.toolTipWareProbability.clear();
    },
    /**
     * 全部移除
     * @method
     * @memberOf G.biz.TyphoonForecast.prototype
     * 
     */      
    clear(){
        this.clearTyphoon();
        this.clearProbability();
    },

    service: null,

    /**
     * 设置数据请求service
     * @method
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param service
     */
    setService(service) {
        this.service = service;
    },
    
    typhoonTooltipHash:{},
    probabilityTooltipHash:{},
    
    _showTyphoon(opts){
        return new Promise((resolve, reject) => {
            if (opts.id) {
                this.removeTyphoon(opts.id);
            }
            let geojson = this._getGeojson(opts);
            if (!geojson.features||geojson.features.length<1) {
                reject(new Error('无空间信息'));
                return;
            }            
            this._drawTyphoon(geojson,opts);
        });
    },  
    _showProbability(opts){
        return new Promise((resolve, reject) => {
            if (opts.id) {
                this.removeProbability(opts.id);
            }        
            let geojson = this._getGeojson(opts);
            if (!geojson.features||geojson.features.length<1) {
                reject(new Error('无空间信息'));
                return;
            }
            this._drawProbability(geojson,opts);
        });

    },    
    _getGeojson(opts){
        let geojson = null;
        //geojson格式
        if (opts.format&&opts.format.toLowerCase()=="geojson") {
            geojson = opts.data;
            //geojson格式字符串
            if (CommonUtil.isString(geojson)) {
                geojson = JSON.parse(geojson);
            }
        }else{
            let xmlObject = opts.data
            if (CommonUtil.isString(xmlObject)) {
                const xmlParser = new DOMParser();
                xmlObject = xmlParser.parseFromString(xmlObject, "text/xml");
            }
            const toGeoJSON = G.utils.GeoJSONUtil;
            geojson = toGeoJSON.fromKml(xmlObject);
        }
        return geojson;
    },

    _drawTyphoon(geojson,opts){
        if (!!opts.id) {
            this.typhoonTooltipHash[opts.id]=[];
        }
        for (let index = 0; index < geojson.features.length; index++) {
            const feature = geojson.features[index];
            //预测圈
            if (feature.geometry.type == "Point") { //预测点、台风点
                var tooltips = this._getForcastRangeTooltips(feature);
                tooltips.forEach(tooltip => {
                    this.toolTipWareTyphoon.add(tooltip);
                    if (!!opts.id) {
                        this.typhoonTooltipHash[opts.id].push(tooltip.id);
                    }
                });
            } else { //范围多边形、轨迹线
                var element = this._parseElement(feature,opts);
                this.typhoonLayer.add(element);
            }
        }
    },
    _drawProbability(geojson,opts){
        const label = opts.label||{};    
        if (!!opts.id) {
            this.probabilityTooltipHash[opts.id]=[];
        }            
        for (let index = 0; index < geojson.features.length; index++) {
            const feature = geojson.features[index];
            //预测圈
            var element = this._parseElement(feature,opts);
            this.probabilityLayer.add(element);
            //概率标识文字
            if (label.display!=false) {
                var tooltip = this._parseTooltipFromPolygon(feature,opts);
                this.toolTipWareProbability.add(tooltip);
                if (!!opts.id) {
                    this.probabilityTooltipHash[opts.id].push(tooltip.id);
                }                
            }            
        }        

    },    
    _parseElement(feature,opts) {
        //样式构建器
        let styleFunc = this._getSymbol;
        if (opts.style) {
            styleFunc=opts.style;
        }
        let SymbolBuilder = G.utils.SymbolBuilder.extend({
            build: function(feature) {
                return styleFunc(feature);
            }
        })
        var symbolBuilderInstance = new SymbolBuilder();
        //几何对象构建器
        var geomBuilderInstance = new G.utils.GeometryBuilder({
            geometryField: ["geometry"]
        });
        //要素构建
        var elementBuilder = new G.utils.FeatureBuilder({
            geometryBuilder: geomBuilderInstance,
            symbolBuilder: symbolBuilderInstance
        });
        var element = elementBuilder.buildElement(feature);
        element.id = opts.id;
        return element;
    },
    _getSymbol(feature) {
        //样式
        //透明度
        var opacity = 1;
        if (feature.properties["fill-opacity"]) {
            opacity = feature.properties["fill-opacity"];
        } else if (feature.properties["stroke-opacity"]) {
            opacity = feature.properties["stroke-opacity"];
        }
        var opacity_g2 = 255 * opacity;

        //填充色
        var fill = {
            r: 100,
            g: 100,
            b: 100,
            a: 255
        };
        if (feature.properties["fill"]) {
            fill = g2.sfs.Color.fromHex(feature.properties["fill"]);
        } else if (feature.properties["stroke"]) {
            fill = g2.sfs.Color.fromHex(feature.properties["stroke"]);
        }
        fill.a = opacity_g2;

        var geomType = feature.geometry.type;
        var style = {};
        if (geomType == "Polygon") {
            style = {
                "type": "SimpleFillSymbol",
                "options": {
                    "borderColor": fill,
                    "fillColor": fill,
                    "borderThickness": 3
                }
            };
        } else if (geomType == "LineString") {
            style = {
                "type": "SimpleLineSymbol",
                "options": {
                    "color": fill,
                    "width": 3
                }
            };
        }
        var symbol = G.utils.RenderUtil.object2Symbol(style);
        return symbol;
    },
    _getForcastRangeTooltips(feature) {
        var result = [];
        var anchor = {
                x: feature.geometry.coordinates[0],
                y: feature.geometry.coordinates[1]
            }
            //轨迹点图标
        var _icon = feature.properties.icon;
        var _iconhtml = '<div style = ""><img height="16" width = "16" src="data/' + _icon + '"/></div>';
        var tooltipIcon = new g2.widget.Tooltip({
            id: CommonUtil.newUUID32(),
            anchor: anchor,
            content: _iconhtml,
            offset: [-8, -8]
        });
        result.push(tooltipIcon);

        //轨迹点文字
        var _text = feature.properties.name;
        _text=Chinese.t2s(_text);
        var _texthtml = '<div style = "font-size:6px"><span>' + _text + '</span></div>';
        var tooltipText = new g2.widget.Tooltip({
            id: CommonUtil.newUUID32(),
            anchor: anchor,
            content: _texthtml,
            offset: [5, 0]
        });
        result.push(tooltipText);
        return result;
    },    
    //构造标识
    _parseTooltipFromPolygon(feature,opts) {
        var geomBuilderInstance = new G.utils.GeometryBuilder({
            geometryField: ["geometry"]
        });
        var _text = feature.properties.name;
        _text=Chinese.t2s(_text);
        var _html = "<div style='width:20px'><span>" + _text + "</span><div>"
        var geom = geomBuilderInstance.build(feature);
        var anchor = this._getLabelAnchor(geom,opts);
        var tooltip = new g2.widget.Tooltip({
            id: CommonUtil.newUUID32(),
            anchor: anchor,
            content: _html,
            offset: [-10, -5]
        });
        return tooltip;
    },
    //获取预测圈顶点点位
    _getLabelAnchor(geom,opts) {
        var labelConf = opts.label||{};
        var _position = labelConf.position||"left";
        var points = geom.shell.points;
        var compare = function(a, b) {
            return a.x < b.x
        }
        switch (_position) {
            case "left":
                compare = function(a, b) {
                    return  a.x - b.x
                }            
                break;
            case "right":
                compare = function(a, b) {
                    return b.x-a.x
                }            
                break;
            case "bottom":
                compare = function(a, b) {
                    return a.y - b.y
                }        
                break;
            case "top":
                compare = function(a, b) {
                    return b.y-a.y
                }         
                break;
        }
        
        var sortedPoints = points.sort(compare);
        var x = sortedPoints[0].x;
        var y = sortedPoints[0].y;
        var _point = {
            x: x,
            y: y
        };
        return _point;
    },
    //参数合并
    _mergeOptions:function(dest){
        var i,j,len,src;
        for (var j=1,len=arguments.length;j<len;j++){
            src=arguments[j];
            for (i in src){
                dest[i]=src[i]
            }
        }
        return dest
    }
});
module.exports= component;
